// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Oman */
const OM = /^(?:(?:1505|90[1-9]\d)\d{4}|(?:7[124-9]|9[1-9])\d{6})$/;

export default OM;
